import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { PainSection } from './components/PainSection';
import { FalseBelief } from './components/FalseBelief';
import { ThreeDoors } from './components/ThreeDoors';
import { OldSolutions } from './components/OldSolutions';
import { WhatIncludes } from './components/WhatIncludes';
import { ForWhom } from './components/ForWhom';
import { Transformation } from './components/Transformation';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-dark-900 text-text-main overflow-x-hidden selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningLead data-id="element-2" />
      <PainSection data-id="element-3" />
      <FalseBelief data-id="element-4" />
      <ThreeDoors data-id="element-5" />
      <OldSolutions data-id="element-6" />
      <WhatIncludes data-id="element-7" />
      <ForWhom data-id="element-8" />
      <Transformation data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}